import { URL } from 'url';
import { StepAction } from './stepAction';
import type { NavigationStep } from 'clickim/src/common/models/navigationStep';

export class NavigationStepAction extends StepAction<NavigationStep> {
    private async updateBaseUrl(location: string) {
        const orgUrl = new URL(location);
        const baseLocation = new URL(this.context.recordedBaseUrl);
        const newBaseLocation = new URL(this.context.baseUrl);
        if (orgUrl.host === baseLocation.host && baseLocation.host !== newBaseLocation.host) {
            orgUrl.host = newBaseLocation.host;
        }
        return orgUrl.href;
    }

    override async performAction() {
        // @ts-expect-error This needs to be further checked. not sure if this is a bug or bad typing.
        const url: string = this.context.data.testimNavigationStepDestination || this.context.data.url;
        // Opens a new tab and switches to new tab
        if (this.step.openInNewTab) {
            await this.driver.client!.newWindow(url);
            return;
        }
        const updatedUrl = await this.updateBaseUrl(url);
        await this.driver.url(updatedUrl);
    }
}
